// Author Lin
// Date 2023-04-20 15:48:02

class SithMesPrdRoutingMaintain {
constructor({
        id = null,
        materialNumber = '',
        projectKamId = '',
        specialProcess = '',
        makerLogin = '',
        proofLogin = '',
        reviewerLogin = '',
        orderConvertLogin = '',
        drawingUploadLogin = '',
        status = '',
        workOrderCode = '',
        remark = ''}
= {}) {
    this.id = id;
    this.materialNumber = materialNumber;
    this.projectKamId = projectKamId;
    this.specialProcess = specialProcess;
    this.makerLogin = makerLogin;
    this.proofLogin = proofLogin;
    this.reviewerLogin = reviewerLogin;
    this.orderConvertLogin = orderConvertLogin;
    this.drawingUploadLogin = drawingUploadLogin;
    this.status = status;
    this.workOrderCode = workOrderCode;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdRoutingMaintain();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'statusName',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialDesc',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.materialDesc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectKamId',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.projectKamId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.enNetworkCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.enActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'specialProcess',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.specialProcess',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '无' },
                            { value: '2', text: '编程' },
                            { value: '3', text: '焊接' },
                            { value: '4', text: '热处理' }
            ]
        }
        },
        {
        key: 'maker',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.maker',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'proof',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.proof',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'reviewer',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.reviewer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'orderConvert',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.orderConvert',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'drawingUpload',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.drawingUpload',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    materialNumberFilter : '',
    projectKamIdFilter : '',
    enNetworkCodeFilter : '',
    enActivityIdFilter : '',
    specialProcessFilter : '',
    makerLoginFilter : '',
    makerFilter : '',
    proofLoginFilter : '',
    proofFilter : '',
    reviewerLoginFilter : '',
    reviewerFilter : '',
    orderConvertLoginFilter : '',
    orderConvertFilter : '',
    drawingUploadLoginFilter : '',
    drawingUploadFilter : '',
    statusFilter : '',
    workOrderCodeFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'materialNumberFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.materialNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'enNetworkCodeFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.enNetworkCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'enActivityIdFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.enActivityId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'specialProcessFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.specialProcess',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '无' },
                { value: '2', text: '编程' },
                { value: '3', text: '焊接' },
                { value: '4', text: '热处理' }
            ]
        }
        },
        {
        key: 'makerFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.maker',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'proofFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.proof',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reviewerFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.reviewer',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderConvertFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.orderConvert',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'drawingUploadFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.drawingUpload',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesPrdRoutingMaintain',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectKamId',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.entity.projectKamId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdProjectKam'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'specialProcess',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.entity.specialProcess',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '无' },
                { value: '2', text: '编程' },
                { value: '3', text: '焊接' },
                { value: '4', text: '热处理' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdRoutingMaintain.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdRoutingMaintain, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
